import { Favorite, FavoriteBorder } from "@mui/icons-material";
import { CircularProgress, Fab, Tooltip } from "@mui/material";
import * as React from "react";
import { XArticleContext } from "../../../context/XArticleProvider";
import { useWishlist } from "../../../hooks/useWishlist";
import { ICartItem } from "../../../utils/constants/dynamic/article";

const AddToWishListBtn: React.FC = () => {
  const [loading, setLoading] = React.useState<boolean>(false);
  const { wishlist, setWishlist } = useWishlist();

  const article = React.useContext(XArticleContext);

  const isActived = !!wishlist.carts.find((e) => e.id === article.id);

  const addToWishList = async () => {
    setLoading(true);
    try {
      setWishlist((old) => {
        const carts: ICartItem[] = isActived
          ? old.carts.filter((e) => e.id !== article.id)
          : [...old.carts, { ...article, qty: 1 }];

        return { ...old, carts };
      });
    } catch (error) {
      console.error("ERROR/ ADDING TO CART BTN =>", error);
    }
    setLoading(false);
  };

  const content = (
    <Fab
      className={isActived ? "isActived" : undefined}
      size="small"
      onClick={addToWishList}
      disabled={loading}
    >
      {loading && <CircularProgress style={{ width: 30, height: 30 }} />}
      {!loading && (!isActived ? <FavoriteBorder /> : <Favorite />)}
    </Fab>
  );

  if (loading) return content;

  return (
    <Tooltip
      title={isActived ? "Retirer des Favoris" : "Ajouter au Favoris"}
      placement="left"
    >
      {content}
    </Tooltip>
  );
};

export default AddToWishListBtn;
